import React, { Component } from 'react';
import '../styles/time-label.css';
import { cls } from '../../../packages/components';

class TimeLabel extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const customCss = this.props.customCss ? this.props.customCss : '';
    return (
      <div ref="time" className={cls(`time-label-container ${customCss}`)}>
        {this.props.time}
      </div>
    );
  }
}

export default TimeLabel;



// WEBPACK FOOTER //
// ./src/playerDomain/components/common/TimeLabel.js